/* eslint no-template-curly-in-string: "off" */

import { PAYMENT_STATUSES } from "../../utils/enums";

const paypalLogo = require("../../assets/images/logo-paypal.png");
const paypalCompleteImg = require("../../assets/images/paypal-confirm.png");

export const paypalPayouts = {
  id: "PAYPAL_PAYOUTS",
  displayName: "PayPal",
  paymentFlow: "oauth",
  cssClassPrefix: "paypal",
  themeColor: "#009cde",
  errors: {
    acceptPayment: {
      title: "Error Transferring Funds",
      message:
        "An error occurred when applying the credit to the PayPal account specified. Please select a different payment method."
    },
    // uiErrors: {
    //   [ERROR_TYPES.UI_ERRORS.FAILED_PAYMENT]: {
    //     title: "Payment Failed",
    //     description: "An error occurred while processing your payment. Please try your request again, or select a different payment network.",
    //   },
    // },
  },
  faqs: {
    byPaymentStatus: {
      [PAYMENT_STATUSES.PENDING_ACCEPTANCE]: [
        {
          answer: "In order to provide payment directly to your account with these services, you must (a) verify your identity and (b) permit us to receive information about your PayPal account. Please note that the login process is provided by PayPal and ${programName} never sees or receives your login information. All of these actions use industry-standard security methods to ensure that your data is protected.",
          question: "Why am I being asked to provide my username and password for PayPal®?"
        }
      ]
    }
  },
  paywall: {
    tile: {
      displayName: ["PayPal"],
      tagline: ["Immediately available funds"],
      description: [
        {
          string: "Direct deposit into your validated PayPal account",
          type: "div",
        },
      ],
      logo: paypalLogo,
      // btnLabel: "Next"
    }
  },
  recipientLogin: {
    flow: "oauth",
    redirectingToOauth: {
      title: "Redirecting to PayPal",
    },
  },
  acceptPayment: {
    imgSrc: paypalCompleteImg,
    byCurrencySelector: {
      RECIPIENT: {
        flow: 'select-currency',
      },
      CUSTOMER: {
        flow: "auto-accept",
      }
    },
    errorMessages: {
      'RECEIVER_COUNTRY_NOT_ALLOWED': 'PayPal has reported an issue with your account and cannot complete your transaction. You may choose a different payment endpoint or contact PayPal directly to resolve any account issues.',
      'RISK_DECLINE': 'PayPal has reported an issue with your account and cannot complete your transaction. You may choose a different payment endpoint or contact PayPal directly to resolve any account issues.',
      'REGULATORY_BLOCKED': 'PayPal has reported an issue with your account and cannot complete your transaction. You may choose a different payment endpoint or contact PayPal directly to resolve any account issues.',
    },
  },
  networkSelectionAccepted: {
    imgSrc: paypalCompleteImg,
    secondaryText: [
      "Upon receipt, you may visit ",
      {
        string: '<a style="font-weight: normal;" href="https://www.paypal.com/myaccount">paypal.com/myaccount</a>',
      },
      " to view your updated balance. A confirmation will be ",
      {
        string: "${payment.recipientNotificationPreference}",
        transformations: [
          {
            type: 'formatPaymentNetworkRecipientType',
          }
        ],
      },
      {
        string: "${payment.recipientNotificationPreference}",
        transformations: [
          {
            type: 'formatEmailAddressOrMobilePhoneNumber',
          },
        ],
        props: {
          className: 'payment-recipientEmail'
        }
      },

    ]
  },
  paymentComplete: {
    initial: {
      secondaryText: [
        "A confirmation email will be sent to ",
        {
          string: "${payment.recipientEmail}",
          props: {
            className: 'payment-recipientEmail'
          }
        },
        ". Please allow a few minutes for your account to update."
      ]
    },
    imgSrc: paypalCompleteImg,
    buttonContainerProps: {
      vertical: true,
    },
    actions: [
      {
        type: "Button",
        props: {
          label: "Shop Now at PayPal",
          href: "https://www.paypal-gifts.com/"
        }
      },
      {
        type: "Button",
        props: {
          label: "View PayPal Balance",
          inverted: true,
          href: "https://www.paypal.com/myaccount/home"
        }
      }
    ],
    affiliateLink: "https://www.paypal.com",
    createAccountLink: "https://www.paypal.com/signup/accountCreate",
    forgotAccountLink:
      "https://www.paypal.com/webapps/accountrecovery/passwordrecovery"
  },
  onHold: {
    imgSrc: paypalCompleteImg,
  }
};

export default paypalPayouts;
